// extracted by mini-css-extract-plugin
export default {"product_drawer_header":"cr","subtitle":"er","in_subscription":"fr","items":"gr","title":"hr","recommended":"ir"};
    if(module.hot) {
      // 1715091669546
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  